// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Cookie from '../classes/Cookie';
import Cookies from '../constants/Cookies';
import Time from '../constants/Time';
import Notifications from '../constants/Notifications';

export default class CookieModal extends Component {
  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    const acceptButton = this.el.getElementByRef('accept-button');
    acceptButton.addEventListener(EventNames.CLICK, (event: Event) => {
      this.notify('changeCookieLoader');
      this.onChange(1);
    });

    const rejectButton = this.el.getElementByRef('reject-button');
    rejectButton.addEventListener(EventNames.CLICK, (event: Event) => {
      this.notify('changeCookieLoader');
      this.onChange(0);
    });

    const cookieModal = document.getElementByRef('cookie-modal');
    if (cookieModal) {
      this.notify(Notifications.TOGGLE_MODAL, { id: 'alert-cookie' });
    }
  }

  /**
   * Executes when one of the options is clicked
   */
  onChange(value: Number): void {
    Cookie.set(Cookies.TRACKING, value, Time.YEAR_IN_SECONDS);
    this.notify(Notifications.COOKIES_CHANGED, { type: 'update', value });
    document.getElementByRef('cookie-modal')?.remove();

    if (value === '0') {
      window.store.sessionManager.clearAllTrackingInformation();
    }
  }
}
